import { Injectable } from '@angular/core';
import {
  LoyaltyProgramNameAttributes,
  TransferConnectV2SettingService,
} from '@features/transfer-connect-v2/services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { LoyaltyProgram } from '@rd/types';
import { RewardsProgramTransferConnectIdentifier } from '../../rewards-program/types';

@Injectable()
export class BnzTransferConnectV2SettingService extends TransferConnectV2SettingService {
  loyaltyProgramNameAttribute: LoyaltyProgramNameAttributes = 'shortName';

  /*
  ====================================
    Review page-only settings
  ====================================
  */

  shouldRenderReviewTnc = true;

  /*
  ====================================
    Success page-only settings
  ====================================
  */

  // [Hau]: Special case for Uber loyalty program
  // we should show the full name of the loyalty currency on the success page
  // instead of the short name
  // Ref: https://kaligo.slack.com/archives/C01MEPFRY06/p1751360284062119?thread_ts=1743410746.561339&cid=C01MEPFRY06
  targetLoyaltyCurrencyNameAttribute: Record<
    LoyaltyProgram['transferConnectIdentifier'],
    LoyaltyProgramNameAttributes
  > = {
    [RewardsProgramTransferConnectIdentifier.Uber]: 'name',
  };
}
